import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';
import Button from 'antd/lib/button';
import {
  currencyFormatter,
} from '../../../common/utils/helpers';
import {
  accountRoles,
} from '../../../common/enums';
import DocumentsPanel from '../../dashboard/components/DocumentsPanel';

@translate()
export default class DisposalItem extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    disposal: PropTypes.object.isRequired,
  };

  state = {
    activePanel: '',
  };

  toggleDocuments = () => {
    this.setState({
      activePanel: this.state.activePanel === 'documents' ? '' : 'documents',
    });
  };

  toggleCalendar = () => {
    this.setState({
      activePanel: this.state.activePanel === 'calendar' ? '' : 'calendar',
    });
  };

  renderStatus() {
    const { disposal } = this.props;

    return (
      <Row end="sm">
        <Col xs>{disposal.status}</Col>
      </Row>
    );
  }

  renderButtons() {
    const { t, disposal } = this.props;

    return (
      <Row between="sm" className="allocation-actions">
        {disposal.contracts.length !== 0 && (
          <React.Fragment>
            <Col xs={12} sm={6}>
              <Button
                type="danger"
                size="default"
                onClick={this.toggleDocuments}
                className="btn-block"
              >
                {t('Dokumenty')}
              </Button>
            </Col>
          </React.Fragment>
        )}
      </Row>
    );
  }

  renderDocumentsPanel() {
    const { disposal } = this.props;
    const { activePanel } = this.state;

    if (activePanel !== 'documents' || disposal.contracts.length === 0) {
      return null;
    }

    return (
      <DocumentsPanel
        contracts={disposal.contracts}
        toggleDocuments={this.toggleDocuments}
        accountRole={accountRoles.CREDITOR}
      />
    );
  }

  render() {
    const { t, disposal } = this.props;

    return (
      <div className="item-wrapper">
        <Row>
          <Col xs={12} sm={6}>
            <h2>
              Odkúpena pôžička #{disposal.loanNumber}
            </h2>
            <p>
              <strong>{t('ODKÚPENÁ ZA')}:</strong>{' '}
              <strong>{currencyFormatter(disposal.amount)}</strong>
            </p>
          </Col>
        </Row>
        {this.renderDocumentsPanel()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/disposals/components/DisposalItem.js